import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

function SolutionItem(props) {
  const { t } = useTranslation();
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });

  const itemName = props.item["item"]["name"];
  const itemLogo = props.item["item"]["itemlogo"];
  const itemImage = props.item["item"]["itemImage"];
  const subtitle = props.item["item"]["subtitle"];
  const explanation = props.item["item"]["explanation"];
  const url = props.item["item"]["url"];

  const handleMouseMove = (e) => {
    setTooltipPosition({
      x: e.clientX + 10,
      y: e.clientY + 10,
    });
  };

  const onClickBtn = () => {
    // if (url) {
    //   window.open(url, "_blank");
    // }
  };

  return (
    <div
      className={"solutionSection1Item " + itemName}
      data-section-index={props.sectionIndex}
    >
      <div className="solutionSection1LeftItem">
        <div className="solutionSection1ItemLogoArea">
          <div className="solutionSection1ItemLogo">{itemLogo}</div>
          <div className="solutionSection1Itemsubtitle">
            <div className="solutionSection1ItemsubtitleText">{subtitle}</div>
          </div>
        </div>
        <div className="solutionSection1ItemExplanation">
          {explanation["text"].map((text, idx) => (
            <div className="solutionSection1ItemExplanationTextWrap" key={idx}>
              <div className="solutionSection1ItemExplanationCircle"></div>
              <div className="solutionSection1ItemExplanationText">
                {text}
                <div className="solutionSection1ItemExplanationSubTextWrap">
                  {idx === 0 && explanation["subText"]
                    ? explanation["subText"].map((subText, idx) => (
                        <div
                          key={idx}
                          className="solutionSection1ItemExplanationSubText"
                        >
                          - {subText}
                        </div>
                      ))
                    : ""}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="solutionSection1RightItem">
        <div className="solutionSection1ItemImage">{itemImage}</div>
        <div
          onClick={onClickBtn}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
          onMouseMove={handleMouseMove}
          className="relative inline-block bg-neutral-300 w-full  text-white transition-all duration-300 text-center p-2 rounded-md mt-5"
        >
          <div className="">{t(`solution.section1Item.imgBtn`)}</div>
          {showTooltip && (
            <div
              className="fixed z-50 pointer-events-none bg-slate-900 p-1 rounded-md text-xs font-bold px-2"
              style={{
                left: `${tooltipPosition.x}px`,
                top: `${tooltipPosition.y}px`,
              }}
            >
              {t(`solution.preparing`)}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default SolutionItem;
